// src/pages/sessions/components/LiveSession/layout/SessionHeader.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import ConnectionStatus from '../../shared/ConnectionStatus';
import SessionTimer from './SessionTimer';

const SessionHeader = ({ 
  sessionData, 
  currentVirtualRoom, 
  roomConnected, 
  onLeave,
  isTablet = false,
}) => {
  const { t } = useTranslation();

  const getSessionTitle = () => {
    if (!sessionData) return t('liveSession.loading');
    
    const parts = [];
    
    if (sessionData.courseName || sessionData.course_name) {
      parts.push(sessionData.courseName || sessionData.course_name);
    }
    
    const sessionNum = sessionData.sessionNumber || sessionData.session_number;
    if (sessionNum) {
      parts.push(t('sessions.sessionNumber', { number: sessionNum }));
    }
    
    if (sessionData.title && sessionData.title !== sessionData.courseName) {
      parts.push(sessionData.title);
    }
    
    if (currentVirtualRoom) {
      parts.push(currentVirtualRoom.display_name || t('videoGrid.room', { number: currentVirtualRoom.room_number }));
    }
    
    return parts.length > 0 ? parts.join(' • ') : t('sessions.session');
  };

  // Check if recording is enabled
  const isRecording = sessionData?.recording_enabled || sessionData?.recordingEnabled;

  return (
    <div
      className="bg-gray-800 border-b border-gray-700 px-4 flex items-center flex-shrink-0 z-10"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        minHeight: 'calc(env(safe-area-inset-top) + 56px)',
      }}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-4 flex-1 min-w-0">
          <h1 className={`text-white font-semibold truncate ${isTablet ? 'text-sm max-w-[180px] sm:max-w-xs' : ''}`}>
            {getSessionTitle()}
          </h1>
          
          {/* Recording Indicator */}
          {isRecording && roomConnected && (
            <div className="flex items-center space-x-1.5 px-2.5 py-1 bg-red-500/20 rounded-md">
              <div className="relative flex items-center">
                <div className="absolute w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                <div className="w-2 h-2 bg-red-500 rounded-full"></div>
              </div>
              <span className="text-xs font-medium text-red-400">{t('liveSession.recording')}</span>
            </div>
          )}
          
          {roomConnected && <SessionTimer />}
        </div>
        
        <div className="flex items-center space-x-2 flex-shrink-0">
          <ConnectionStatus />
          <button
            onClick={onLeave}
            className="px-3 py-1 bg-gray-600 text-white rounded text-sm hover:bg-gray-700 transition-colors"
          >
            {t('controls.leaveSession')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionHeader;